import { Routes } from '@angular/router';
import { authGuard } from './core/guard/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./core/layout/layout.component').then(m => m.CoreLayoutComponent),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'catalog',
        pathMatch: 'full'
      },
      {
        path: 'catalog',
        loadComponent: () => import('./components/catalog/catalog.component').then(m => m.CatalogComponent),
        children: [
          { path: ':id', children: [] }
        ]
      },
      {
        path: 'collections',
        loadComponent: () => import('./components/collections/collections.component').then(m => m.CollectionsComponent),
        children: [
          { path: ':id', children: [] }
        ]
      }
    ]
  }
];
